import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'datatables.net-bs5'; // Import DataTables.js
import "datatables.net-responsive/js/dataTables.responsive.min.js";
import $ from "jquery";
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import config from '../config';

const ClientTable = () => {
    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchClients = async () => {
            try {
                const response = await axios.get(`${config.API_BASE_URL}/api/master/`);
                setClients(response.data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching clients:', error);
                setLoading(false);
            }
        };

        fetchClients();
    }, []);

    useEffect(() => {
        // Initialize DataTables when data is loaded
        if (!loading) {
            // Destroy the existing DataTable before initializing again
            if ($.fn.dataTable.isDataTable('#clientsTable')) {
                $('#clientsTable').DataTable().destroy();
            }
            $('#clientsTable').DataTable({
                responsive: true,
                colReorder: true,
                layout: {
                    bottomEnd: {
                        paging: {
                            firstLast: false
                        }
                    }
                }
            });
        }
    }, [clients, loading]);

    return (
        <>
            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <>
                    {clients.length === 0 ? (
                        <div className="text-center py-3 fs-7 text-muted fw-semibold opacity-50">No client found</div>
                    ) : (
                    <table id="clientsTable"
                        className="display responsive nowrap table table-sm fs-9 mb-0"
                        style={{ width: "100%" }} >
                        <thead>
                            <tr>
                                <th>SN</th>
                                <th>Company</th>
                                <th>Subdomain</th>
                                <th>DB Name</th>
                                <th>Plan</th>
                                <th>Status</th>
                                <th>Joined</th>
                                <th>Subscription Start</th>
                                <th>Subscription End</th>
                            </tr>
                        </thead>
                        <tbody>
                            {clients.map((client, index) => (
                                <tr key={client._id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <Link
                                            to={`/clients/${client._id}`}
                                            className="text-decoration-none"
                                        >
                                            {client.companyName}
                                        </Link>
                                    </td>
                                    <td>{client.subdomain}</td>
                                    <td>{client.dbName}</td>
                                    <td>
                                        <span className="badge bg-primary">{client.plan || 'N/A'}</span>
                                    </td>
                                    <td>
                                        <span className={`badge ${client.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                                            {client.status}
                                        </span>
                                    </td>
                                    <td>{client.createdAt ? format(new Date(client.createdAt), 'd MMM, yyyy') : 'N/A'}</td>
                                    <td>
                                        {client.subscriptionStart ? format(new Date(client.subscriptionStart), 'd MMM, yyyy') : 'N/A'}
                                    </td>
                                    <td>{client.subscriptionEnd ? format(new Date(client.subscriptionEnd), 'd MMM, yyyy') : 'N/A'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    )}
                </>
            )
            }
        </>
    );
};

export default ClientTable;
